import { cn } from '@/lib/utils';

/** Laadvorm in de vorm van de echte inhoud (design-skill: Skeleton, pas na ~300ms nodig). */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-md bg-muted', className)} />;
}
